import React, { useEffect, useState } from "react";
import "./ClassRankingPage.css";
import axios from "../axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilterCircleXmark } from "@fortawesome/free-solid-svg-icons";

function ClassRankingPage({
  student,
  startDate,
  endDate,
  assessmentTypeId,
  subjectWiseData,
  subjectList,
}) {
  const [expanded, setExpanded] = useState(false);
  const [studentRankData, setStudentRankData] = useState([]);
  const [supplementTypesName, setSupplementTypesName] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedSupplement, setSelectedSupplement] = useState("");
  const [selectedSupplementName, setSelectedSupplementName] = useState("");
  const [bookId, setBookId] = useState("");
  const [chapterId, setChapterId] = useState("");

  useEffect(() => {
    if (
      !startDate ||
      !endDate ||
      !student?.id ||
      !student?.standard?.id ||
      !student?.section?.id
    )
      return;
    const fetchstudentRankData = async () => {
      try {
        const response = await axios.get(
          `/performance/student/${student?.id}/standard/${student?.standard?.id}/section/${student?.section?.id}/studentsRank/get?startDate=${startDate}&endDate=${endDate}&subjectId=${selectedSubject}&bookId=${bookId}&chapterId=${chapterId}&supplementId=${selectedSupplementName}&assessmentEventId=${assessmentTypeId}`,
        );

        setStudentRankData(response?.data?.data);
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchstudentRankData();
  }, [startDate, endDate, student, selectedSupplementName, assessmentTypeId]);
  useEffect(() => {
    if (
      !startDate ||
      !endDate ||
      !student?.id ||
      !student?.standard?.id ||
      !student?.section?.id
    )
      return;
    const fetchSupplementTypesName = async () => {
      try {
        const response = await axios.get(
          `/performance/standard/${student?.standard?.id}/section/${student?.section?.id}/student/${student?.id}/supplementTypeList/get?startDate=${startDate}&endDate=${endDate}&subjectId=${selectedSubject}&assessmentEventId=${assessmentTypeId}`,
        );
        setSupplementTypesName(response?.data?.data);
      } catch (error) {
        console.log("error", error);
      }
    };
    if (selectedSubject) {
      fetchSupplementTypesName();
    }
  }, [
    startDate,
    endDate,
    student,
    selectedSupplementName,
    assessmentTypeId,
    selectedSubject,
  ]);

  const sortedStudents = (studentRankData || []).sort(
    (a, b) => b.rankPercentage - a.rankPercentage,
  );

  let rankedList = [];
  let prevPercentage = null;
  let prevRank = 0;

  for (let i = 0; i < sortedStudents.length; i++) {
    const student = sortedStudents[i];

    if (prevPercentage !== null && student.rankPercentage === prevPercentage) {
      // Same percentage → same rank
      rankedList.push({ ...student, realRank: prevRank });
    } else {
      // Different percentage → rank = prevRank + 1
      const newRank = prevRank + 1;
      rankedList.push({ ...student, realRank: newRank });
      prevRank = newRank;
    }

    prevPercentage = student.rankPercentage;
  }

  // const ranks = studentRankData || [];
  const loggedInStudent = rankedList.find((s) => s._id.student === student?.id);

  const displayedRanks = rankedList.slice(0, 5);
  if (loggedInStudent && !displayedRanks.includes(loggedInStudent)) {
    displayedRanks.push(loggedInStudent);
  }
  const subjectsSubjectDetails =
    subjectWiseData?.map((subject) => ({
      id: subject?.result?.[0]._id,
      name: subject?.result?.[0]?.name,
    })) || [];

  return (
    <div className="card-class-rank mt-2">
      <div className="flex items-center justify-between mb-2 p-3 h-16 bg-gray-200">
        <h2 className="card-title">Ranking in Class</h2>
        <div className="filter-group-classRank">
          <select
            value="Assessment"
            onChange={(e) => setSelectedSupplement(e.target.value)}
            className="form-select"
          >
            <option value="">Supplemnent Type</option>
            <option value="Assessment">Assessment</option>
          </select>

          <select
            value={selectedSubject}
            onChange={(e) => setSelectedSubject(e.target.value)}
            className="form-select"
          >
            <option value="">Subject Name</option>
            {subjectList?.map((subject, index) => (
              <option key={subject.id} value={subject.id}>
                {subject?.name}
              </option>
            ))}
          </select>

          <select
            value={selectedSupplementName}
            onChange={(e) => setSelectedSupplementName(e.target.value)}
            className="form-select"
          >
            <option value="">Supplement Name</option>
            {selectedSubject &&
              supplementTypesName?.flatMap((item) =>
                item.assessmentsList?.map((assessment) => (
                  <option
                    key={assessment.assessmentId}
                    value={assessment.assessmentId}
                  >
                    {`${new Date(
                      assessment.scheduleDate,
                    ).toLocaleDateString()} - ${assessment.assessmentName}`}
                  </option>
                )),
              )}
          </select>

          <button
            className="clear-filter-btn"
            onClick={() => {
              setSelectedSubject("");
              setSelectedSupplement("");
              setSelectedSupplementName("");
            }}
            title="Clear Filter"
          >
            <FontAwesomeIcon icon={faFilterCircleXmark} />
          </button>
        </div>
      </div>

      <hr className="separator" />

      <div className="card-content-class-rank p-4">
        <div className="ranking-list">
          {rankedList.length === 0 ? (
            <div className="no-data">No data available</div>
          ) : expanded ? (
            rankedList.slice(0, 50).map((s, index) => (
              <div
                key={s._id.student}
                className={`rank-row ${
                  s._id.student === student?.id ? "highlighted" : ""
                }`}
              >
                <span>
                  Rank #{s.realRank} {s.name}
                </span>
                <span>{s.rankPercentage.toFixed(2)}%</span>
              </div>
            ))
          ) : (
            displayedRanks.map((s, index) => (
              <div
                key={s._id.student}
                className={`rank-row ${
                  s._id.student === student?.id ? "highlighted" : ""
                }`}
              >
                <span>
                  Rank #{s.realRank} {s.name}
                </span>
                <span>{s.rankPercentage.toFixed(2)}%</span>
              </div>
            ))
          )}
        </div>

        {rankedList.length > 5 && (
          <div className="expand-btn-wrapper">
            <button
              className="showTablebutton"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? "Collapse" : "Expand"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ClassRankingPage;
